import {useQuery} from '@tanstack/react-query';
import {GetProvidersDetailsModel} from 'domain/usecases';
import {UseOdontoProviderDetailsParams} from './types';
import {getOdontoProviderDetails} from '../../services/getOdontoProviderDetails';

export function useOdontoProviderDetailsQuery(params: UseOdontoProviderDetailsParams) {
	const shouldFetchProviderDetails = Boolean(
		params.cdPrestador && params.nmCidade && params.dsTipo && params.cdUf,
	);

	const {data, isLoading, isError} = useQuery<GetProvidersDetailsModel>({
		queryKey: ['odontoProviderDetails', params],
		queryFn: ({signal}) => getOdontoProviderDetails({...params, signal}),
		enabled: shouldFetchProviderDetails,
	});

	return {
		data,
		isLoading,
		isError,
	};
}
